import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useContext, useRef, useEffect } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import TabsContext from './context';
import { tuple } from '../_utils/type';
export var TabPaneTypes = tuple('line', 'card', 'grid', 'dynamic');

var TabPane = function TabPane(props) {
  var _context, _context2, _context3, _classNames, _classNames2;

  var context = useContext(TabsContext);
  var tabPaneRef = useRef(null);

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var tab = props.tab,
      id = props.id,
      className = props.className,
      disabled = props.disabled,
      operations = props.operations,
      onChange = props.onChange;

  var tabPaneProps = _extends({}, props);

  if (context) {
    tabPaneProps.activeKey = context.activeKey;
    tabPaneProps.type = context.type;
    tabPaneProps.position = context.position;
    tabPaneProps.size = context.size;
    tabPaneProps.disabled = context.disabled || disabled;
  }

  var tabPanePrefixCls = getPrefixCls(prefixCls, 'tab-pane');
  var tabPaneBoxClasses = classNames(tabPanePrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(tabPanePrefixCls, "-box-active"), String(tabPaneProps.activeKey) === String(id) && !tabPaneProps.disabled), _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(tabPanePrefixCls, "-type-")).call(_context, tabPaneProps.type), tabPaneProps.type), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(tabPanePrefixCls, "-")).call(_context2, tabPaneProps.position), tabPaneProps.position), _defineProperty(_classNames, _concatInstanceProperty(_context3 = "".concat(tabPanePrefixCls, "-")).call(_context3, tabPaneProps.size), tabPaneProps.size), _defineProperty(_classNames, "".concat(tabPanePrefixCls, "-disabled"), tabPaneProps.disabled), _classNames));
  var tabPaneTextClasses = classNames("".concat(tabPanePrefixCls, "-text"), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(tabPanePrefixCls, "-text-active"), String(tabPaneProps.activeKey) === String(id) && !tabPaneProps.disabled), _defineProperty(_classNames2, "".concat(tabPanePrefixCls, "-text-disabled"), tabPaneProps.disabled), _classNames2));
  var operationsClasses = classNames("".concat(tabPanePrefixCls, "-operations"), _defineProperty({}, "".concat(tabPanePrefixCls, "-operations-active"), String(tabPaneProps.activeKey) === String(id) && !tabPaneProps.disabled));

  var handleClick = function handleClick(e) {
    if (tabPaneProps.disabled) return;
    onChange && onChange(id, e);
  };

  useEffect(function () {
    var _a, _b;

    if (String(tabPaneProps.activeKey) === String(id)) {
      context === null || context === void 0 ? void 0 : context.getActiveLinePosition(((_a = tabPaneRef.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0, ((_b = tabPaneRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0);
    }
  }, [tabPaneRef, tabPaneProps.activeKey, id, context]);

  var renderOperations = function renderOperations() {
    if (!(operations === null || operations === void 0 ? void 0 : operations.length)) return null;
    return operations === null || operations === void 0 ? void 0 : _mapInstanceProperty(operations).call(operations, function (op, index) {
      var event = function event() {
        op.props.onClick && op.props.onClick(id);
      };

      return /*#__PURE__*/React.createElement("span", {
        key: index,
        onClick: event
      }, op);
    });
  };

  var handleContextMenu = function handleContextMenu(e) {
    if (tabPaneProps.type !== 'dynamic') return;
    e.preventDefault();
    context === null || context === void 0 ? void 0 : context.getTriggerKey(id);
  };

  if (tabPaneProps.type !== 'dynamic') {
    return /*#__PURE__*/React.createElement("span", {
      ref: tabPaneRef,
      className: tabPaneBoxClasses,
      onClick: handleClick
    }, /*#__PURE__*/React.createElement("span", {
      className: tabPaneTextClasses
    }, tab));
  }

  return /*#__PURE__*/React.createElement("span", {
    className: tabPaneBoxClasses,
    onContextMenu: handleContextMenu
  }, /*#__PURE__*/React.createElement("span", {
    ref: tabPaneRef,
    className: tabPaneTextClasses,
    onClick: handleClick
  }, tab), /*#__PURE__*/React.createElement("span", {
    className: operationsClasses
  }, renderOperations()));
};

TabPane.displayName = 'TabPane';
export default TabPane;